"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./IconButton.scss");
var BaseCta_1 = require("../BaseCta/BaseCta");
var key_press_1 = require("../../../utils/key-press");
var enterIsPressed = key_press_1.KeyPress.enterIsPressed;
var IconButton = function (_a) {
    var data = _a.data, testId = _a.testId, options = _a.options, events = _a.events;
    var sizeClass;
    var size = (data === null || data === void 0 ? void 0 : data.size) ? data === null || data === void 0 ? void 0 : data.size : '';
    var url = (data === null || data === void 0 ? void 0 : data.url) ? data === null || data === void 0 ? void 0 : data.url : '';
    var icon = (data === null || data === void 0 ? void 0 : data.icon) ? data === null || data === void 0 ? void 0 : data.icon : '';
    var labelText = (data === null || data === void 0 ? void 0 : data.labelText) ? data === null || data === void 0 ? void 0 : data.labelText : '';
    var disabled = (options === null || options === void 0 ? void 0 : options.disabled) ? options === null || options === void 0 ? void 0 : options.disabled : false;
    var isButtonFace = (options === null || options === void 0 ? void 0 : options.isButtonFace) === false ? false : true;
    var optClass = (options === null || options === void 0 ? void 0 : options.className) ? options === null || options === void 0 ? void 0 : options.className : '';
    var btnRole = (options === null || options === void 0 ? void 0 : options.role) ? options === null || options === void 0 ? void 0 : options.role : undefined;
    var isTooltip = (options === null || options === void 0 ? void 0 : options.isTooltip) ? true : false;
    var ariaLabel = (options === null || options === void 0 ? void 0 : options.ariaLabel) ? options === null || options === void 0 ? void 0 : options.ariaLabel : '';
    switch (size) {
        case 'extraLarge':
            sizeClass = 'width-xl-all height-xl-all';
            break;
        case 'large':
            sizeClass = 'width-lg-all height-lg-all';
            break;
        case 'medium':
            sizeClass = 'width-md-all height-md-all';
            break;
        case 'small':
            sizeClass = 'width-sm-all height-sm-all';
            break;
    }
    ;
    var backColor = (options === null || options === void 0 ? void 0 : options.bgIconColor) ? options === null || options === void 0 ? void 0 : options.bgIconColor : '';
    var btnWithoutLable = '';
    var focusBorderClass = '';
    var lableColorClass = 'color-functional-blue';
    var disabledClass = '';
    var anchorClass = '';
    var iconDivClass = '';
    if (!labelText) {
        if (disabled) {
            disabledClass = styles.cirDisabled;
            btnWithoutLable = '';
            if (!isButtonFace) {
                backColor = '';
            }
        }
        else {
            btnWithoutLable = styles.curOnly;
            if (!isButtonFace) {
                focusBorderClass = backColor === 'bg-ui-background-gray' ? styles.nfGrayBgColor : '';
                backColor = '';
            }
            else {
                focusBorderClass = backColor === 'bg-ui-background-gray' ? '' : styles.wfCobaltBgColor;
            }
        }
        var tabareaClass = '';
        if (!disabled && (size === 'small' || size === 'medium')) {
            tabareaClass = size === 'small' ? styles.smtabarea : styles.mdtabarea;
        }
        anchorClass = ["inline-flex flex-column flex-items-center", disabledClass, tabareaClass, btnWithoutLable].join(" ");
        iconDivClass = ["text-center", styles.borderRadiusIcon, focusBorderClass, backColor, sizeClass].join(" ");
    }
    else {
        if (!isButtonFace) {
            btnWithoutLable = styles.curOnly;
            focusBorderClass = backColor === 'bg-ui-background-gray' ? [styles.nfGrayBgColor].join(" ") : '';
            backColor = '';
        }
        else {
            btnWithoutLable = styles.curOnly;
            focusBorderClass = backColor === 'bg-ui-background-gray' ? '' : [styles.wfCobaltBgColor].join(" ");
        }
        if (disabled) {
            disabledClass = styles.cirDisabled;
            lableColorClass = 'color-ui-gray';
            btnWithoutLable = '';
        }
        anchorClass = ["inline-flex flex-column flex-items-center", disabledClass, btnWithoutLable, 'no-hover'].join(" ");
        iconDivClass = ["text-center", styles.borderRadiusIcon, focusBorderClass, backColor, sizeClass].join(" ");
    }
    var handleClick = function (e) {
        if (disabled) {
            return false;
        }
        if (e.type === 'click' && !url) {
            if (events.onClick) {
                events.onClick(e);
            }
        }
    };
    var handleKeyPress = function (e) {
        if (disabled) {
            return false;
        }
        if (enterIsPressed(e) || e.keyCode === 32) {
            e.stopPropagation();
            e.preventDefault();
            if (url) {
                window.location.href = url;
            }
            else {
                if (events.onClick) {
                    events.onClick(e);
                }
            }
        }
    };
    return ((!isTooltip) ? (React.createElement("a", __assign({ "data-testid": testId, className: anchorClass + " " + optClass }, { "aria-label": ariaLabel ? ariaLabel : undefined }, { tabIndex: !disabled ? 0 : -1 }, { href: !url ? 'javascript:void(0)' : url }, { role: !btnRole ? undefined : btnRole }, { onClick: url ? undefined : handleClick }, { onKeyDown: handleKeyPress }),
        React.createElement("div", { className: iconDivClass }, icon),
        labelText ? React.createElement("span", { className: "line-h-md type-sm " + lableColorClass }, labelText) : '')) :
        (React.createElement(BaseCta_1.BaseCta, __assign({ className: "" + styles.toltipbtn }, { "aria-label": ariaLabel ? ariaLabel : undefined }),
            React.createElement("div", { className: iconDivClass }, icon),
            labelText ? React.createElement("span", { className: "line-h-md type-sm " + lableColorClass }, labelText) : '')));
};
exports.default = IconButton;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/IconButton/IconButton.js
// module id = 1775
// module chunks = 8